<template>
  <div class="oblyk-carousel-item">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'OblykCarouselItem',
  props: {}
}
</script>
